import CityPageTemplate from "../city-template/CityPageTemplate";
import { clintonTownshipConfig } from "./data";

export default function ClintonTownshipPage() {
  return <CityPageTemplate config={clintonTownshipConfig} />;
}